/********************* 文件预览配置 *********************/
// 主要用于一些全局的静态功能配置
// export const FILE_model = ['rvt','ifc','skp','dgn','3dm','3ds','nwc','nwf','fbx','sz-ifc','obj'];
export const FILE_model = ['3dm','3ds','bvh','dae', 'dgn', "dxf", "fbx", "gltf", "ifc", "mdc", "obj", "ply", "rvt", "skp", "stl", "sz-ifc", "3d", "3mf", "ac", "amf", "ase", "b3d", "blend", "cob", "csm", "hmp", "iqm", "lws", "md2", "ms3d", "off", "sib", "smd", "ter", "x3d", "xgl"]
export const FILE_excel = ['xls', 'xlsx']; // ['xls', 'xlsx']
export const FILE_pdf = ['pdf', 'doc','docx','ppt','pptx'];
export const FILEEXT_excel = ['xls', 'xlsx'];
export const FILEEXT_image = ['jpg', 'jpeg', 'png', 'bmp', 'tif', 'gif'];
export const FILEEXT_audio = ['mp3'];
export const FILEEXT_video = ['mp4'];
export const FILEEXT_browse = ['txt'];
export const FILE_collection = ['cpx'];
export const FILE_preview = ['dwg'].concat(FILE_model,FILE_excel, FILE_pdf,FILEEXT_excel,FILEEXT_image,FILEEXT_video,FILEEXT_browse, FILE_collection);
export const STATUS_dwgOrModelStatus = {
    success:1,
    process:2,
    failure:3,
    2:'文件转换中',
    3:'文件转换失败',
};
const processImg = 'static/image/drawSection/load-process.png';
const emptyImg = 'static/image/drawSection/load-empty.png';
const selectImg = 'static/image/drawSection/load-select.png'
const failImg = 'static/image/drawSection/load-fail.png'
const unsupportedImg = 'static/image/drawSection/load-unsupported.png'
export const TXT_loadInfo= {
    success:{
        info:'加载完成',
        img: emptyImg,
    },
    failure:{
        info:"文件转换失败",
        img:failImg,
    },
    empty:{
        info:"请选择预览文件",
        img:emptyImg,
    },
    default:{
        info:"请选择预览文件",
        img:selectImg,
    },
    notSupported:{
        info:"当前文件暂未开放预览",
        img:unsupportedImg,
    },
    process:{
        info: '文件转换中，请稍后查看',
        img:processImg,
    },
    loading:{
        info: '加载中...',
        img:processImg,
    },
    modelProcess:{
        info:'模型转换中，请稍后在再预览',
        img:processImg,
    },
    allModelProcess:{
        info: '所选模型全部未完成转换，请稍后再查看',
        img:processImg,
    }
};
